// Dashboard.js
import React, { useRef, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ReactEditList from "react-edit-list";
import { getDocs, collection, query, addDoc, orderBy, doc, deleteDoc, setDoc, where } from 'firebase/firestore/lite';
import {db} from './../firebase';
import { DASHBOARD_CRUD, notifyDashboardCrudError, failDashboardValidation, isBlank } from '../utils/dashboardCrud';
// import FileUploader from './../FileUploader';

// Using native HTML5 drag and drop
import { useDragAndDrop } from './useDragAndDrop';

export const TesisList = () => {

  const DOCUMENT_NAME = 'tesis';

  const TITLE = 'Tesis';
  
  const [data, setData] = useState([]);
  const dataRef = useRef([]);
  const [tesisTypes, setTesisTypes] = useState([]);
  const [tesisCategories, setTesisCategories] = useState([]);

  const navigate = useNavigate();
  const headers = {
    "title" : "Titulo",
    "type" : "Tipo",
    "category" : "Categoria",
    "status_label" : "Estatus",
    "enabled" : "Mostrar"
  };

  const schema = [
    { name: "id", type: "id" },
    { name: "title", type: "string" },
    { name: "type", type: tesisTypes.map((item) => ({name: item.title, value: item.id})) },
    { name: "category", type: tesisCategories.map((item) => ({name: item.title, value: item.id})) },
    { name: "status_label", type: [
      {name: "En Progreso", value: "En Progreso"},
      {name: "Terminada", value: "Terminada"} 
    ]},
    { name: "enabled", type: [
        { value: true, name: "Si" },
        { value: false, name: "No" }
      ] 
    }
  ];

  const goToDashboard = async () => {
    navigate('/dashboard');
  };

  // Keep dataRef in sync with data state
  useEffect(() => {
    dataRef.current = data;
  }, [data]);

  const ref = useRef(null);
  
  // Use drag and drop hook
  const { initDragAndDrop } = useDragAndDrop(data, setData, dataRef, DOCUMENT_NAME, TITLE, ref);

  const fetchData = async () => {
    try {
      const q = query(collection(db, DOCUMENT_NAME), orderBy('order'));
      const querySnapshot = await getDocs(q);
            const newData = querySnapshot.docs
                .map((doc) => ({ ...doc.data(), id:doc.id }));
            setData(newData);
            dataRef.current = newData;
      
      // Initialize drag and drop after data is loaded
      setTimeout(() => {
        initDragAndDrop();
      }, 1000);
    } catch (error) {
      notifyDashboardCrudError({ operation: DASHBOARD_CRUD.LOAD, entityName: TITLE, error });
      setData([]);
    }
    }

  const fetchTesisTypes = async () => {
    try {
      const q = query(collection(db, 'tesis-types'), where("enabled", "==", true), orderBy('order'));
      const querySnapshot = await getDocs(q);
      const newData = querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
      setTesisTypes(newData);
    } catch (error) {
      notifyDashboardCrudError({ operation: DASHBOARD_CRUD.LOAD, entityName: 'Tipos de tesis', error });
      setTesisTypes([]);
    }
  };

  const fetchTesisCategories = async () => {
    try {
      const q = query(collection(db, 'tesis-categories'), where("enabled", "==", true), orderBy('order'));
      const querySnapshot = await getDocs(q);
      const newData = querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
      setTesisCategories(newData);
    } catch (error) {
      notifyDashboardCrudError({ operation: DASHBOARD_CRUD.LOAD, entityName: 'Categorías de tesis', error });
      setTesisCategories([]);
    }
  };

  useEffect(()=>{
    fetchData();
    fetchTesisTypes();
    fetchTesisCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="container-fluid mt-1">
        <div className="card shadow">
            <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                <button className="btn btn-danger" onClick={goToDashboard} >Regresar</button><h3 className="mb-0">Listado de {TITLE}</h3>
            </div>
            <div className="card-body">
                <div className="table-responsive">
                    <React.Fragment>
                      <div className="m-3 fw-bold">
                        Se pueden reordenar los {TITLE.toLowerCase()} moviendolos de orden en la lista
                      </div>
                      <ReactEditList
                        schema={schema}
                        headers={headers}
                        onLoad={() => data}
                        ref={ref}
                        onUpdate={async (item) => {
                          // Call your API here
                          if (isBlank(item.title)) {
                            return failDashboardValidation({
                              operation: DASHBOARD_CRUD.UPDATE,
                              entityName: TITLE,
                              missingFields: ['Título'],
                              message: 'Debes capturar el título de la tesis.',
                            });
                          }
                          item.enabled = item.enabled === 'false' || item.enabled === false ? false : true;
                          if (!item.status_label)
                          {
                            item.status_label = "En Progreso";
                          }
                          try {
                            await setDoc(doc(db, DOCUMENT_NAME, item.id), item);
                          } catch (error) {
                            notifyDashboardCrudError({ operation: DASHBOARD_CRUD.UPDATE, entityName: TITLE, error });
                            return false;
                          }
                        }}
                        onDelete={async (item) => {
                          if (!window.confirm("Are you sure you want to delete it?")) return false;
                          try {
                            await deleteDoc(doc(db, DOCUMENT_NAME, item.id));
                          } catch (error) {
                            notifyDashboardCrudError({ operation: DASHBOARD_CRUD.DELETE, entityName: TITLE, error });
                            return false;
                          }
                        }}
                        onInsert={ async (item) => {
                          // Call your API here
                          if (isBlank(item.title)) {
                            return failDashboardValidation({
                              operation: DASHBOARD_CRUD.CREATE,
                              entityName: TITLE,
                              missingFields: ['Título'],
                              message: 'Debes capturar el título de la tesis.',
                            });
                          }
                          if (!item.status_label)
                          {
                            item.status_label = "En Progreso";
                          }
                          if ( item.type === undefined )
                          {
                            item.type = tesisTypes.length > 0 ? tesisTypes[0].id : null;
                          }
                          if ( item.category === undefined )
                          {
                            item.category = tesisCategories.length > 0 ? tesisCategories[0].id : null;
                          }
                          item.enabled = item.enabled === 'false' || item.enabled === false ? false : true;
                          item.order = data.length;
                          try {
                            const docRef = await addDoc(collection(db, DOCUMENT_NAME), item);
                            item.id = docRef.id;
                            await setDoc(doc(db, DOCUMENT_NAME, item.id), item);
                          } catch (error) {
                            notifyDashboardCrudError({ operation: DASHBOARD_CRUD.CREATE, entityName: TITLE, error });
                            return false;
                          }
                        }}
                        className="table table-light table-fixed align-middle"
                        headClassName="table-primary"
                        inputClassName="w-100"
                        thClassName={{
                          // These allow to fix the column widths
                          name: "col-3",
                          url_imagen: "col-8",
                          buttons: "col-1",
                        }}
                        bodyClassName="sortable-items"
                        btnValidateClassName="btn btn-success p-0 m-0"
                        btnDeleteClassName="btn btn-danger py-0 px-1 m-0 mx-1"
                        btnCancelClassName="btn btn-secondary py-0 px-1 m-0 mx-1"
                        rowClassName="draggable"
                        insertClassName="not-draggable"
                        filler={<React.Fragment>&#8230;</React.Fragment>}
                      />
                    </React.Fragment>
                </div>
            </div>
        </div>
    </div>
  );
}
